// extracted by mini-css-extract-plugin
export default {"address":"editPrint_address__eouWI","formFields":"editPrint_formFields__J4UO6","corner_button":"editPrint_corner_button__+Wjz8","display_text":"editPrint_display_text__ZDxqL"};